import { Container, Typography } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"

import CommonBackButton from "../../../atoms/CommonBackButton/CommonBackButton"
import MarkdownContent from "../../../atoms/MarkdownContent/MarkdownContent"
import { Route } from "../../../../router"
import { useTranslation } from "react-i18next"
import SplashScreenGuard from "../../../../router/guards/SplashScreenGuard"
import { useEffect, useState } from "react"

const ProgrammeApplicationFormFAQ = () => {
    const { state } = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [faq, setFaq] = useState(``)

    useEffect(() => {
        if (state){
            setFaq(state.faq)
        }
        if (!state && !faq) {
            navigate(Route.HOME)
        }
    }, [state])

    return (
        <SplashScreenGuard>
            <Container>
                <CommonBackButton />
                <Typography variant={`h3`} mt={2}>{t(`programme_application_form_faq`)}</Typography>
                <MarkdownContent content={faq} />
            </Container>
        </SplashScreenGuard>
    )
}

export default ProgrammeApplicationFormFAQ
